/**
 * Andre Garen - Hareket kutuphanesi calisma zamani (ag-fx-*).
 * Yalnizca IntersectionObserver ve gerektiginde requestAnimationFrame
 * kullanir - scroll event listener yok, harici kutuphane yok.
 * Hicbir efekt kendiliginden bir sectiona uygulanmaz; yalnizca ag-fx-*
 * siniflarini tasiyan elemanlari calistirir.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Tur 23 (A): Instagram/Facebook uygulama ici tarayicisi - reveal efekti yok, icerik hemen gorunur. */
  var IAB = /Instagram|FBAN|FBAV|FB_IAB|FB4A/.test(navigator.userAgent);

  /* ---- 1/2/7/9/10: reveal, mask, line, arc, heading - paylasilan "bir kez goster" gozlemcisi ---- */
  var onceEls = document.querySelectorAll('.ag-fx-reveal, .ag-fx-reveal--stagger, .ag-fx-mask, .ag-fx-line, .ag-fx-arc, .ag-fx-heading');
  if (onceEls.length) {
    if (REDUCED || IAB || !('IntersectionObserver' in window)) {
      onceEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var ioCalisti = false;
      /* Tur 23 (A) emniyet: 2500 ms sonra gozlemci hic cagrilmadiysa hepsini, cagrildiysa
         ekranda/ustunde kalip hala gizli olanlari goster - icerik hicbir kosulda gizli kalmaz. */
      setTimeout(function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        onceEls.forEach(function (el) {
          if (el.classList.contains('is-visible')) return;
          if (!ioCalisti || el.getBoundingClientRect().top < vh) el.classList.add('is-visible');
        });
      }, 2500);
      var io = new IntersectionObserver(function (entries, obs) {
        ioCalisti = true;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: .2, rootMargin: '0px 0px -10% 0px' });
      onceEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- 1) reveal--stagger: her cocuga sira numarasi ver (--ag-fx-i) ---- */
  document.querySelectorAll('.ag-fx-reveal--stagger').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.style.setProperty('--ag-fx-i', i);
    });
  });

  /* ---- 9) arc: gercek path uzunlugunu olcup CSS degiskenine yaz ---- */
  document.querySelectorAll('.ag-fx-arc__path').forEach(function (path) {
    try {
      var len = path.getTotalLength();
      path.style.setProperty('--ag-fx-arc-len', len);
    } catch (e) {}
  });

  /* ---- 8) parallax: scroll listener YOK - yalnizca IO + rAF dongusu ---- */
  if (!REDUCED && 'IntersectionObserver' in window) {
    var pEls = document.querySelectorAll('.ag-fx-parallax');
    if (pEls.length) {
      var active = [];
      var looping = false;
      function ptick() {
        if (!active.length) { looping = false; return; }
        var vh = window.innerHeight || document.documentElement.clientHeight;
        active.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
          var clamped = Math.max(-1, Math.min(1, progress));
          var target = el.querySelector('[data-ag-fx-parallax-target]') || el.firstElementChild;
          if (target) target.style.transform = 'translate3d(0,' + (clamped * 8).toFixed(2) + '%,0)';
        });
        requestAnimationFrame(ptick);
      }
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var idx = active.indexOf(entry.target);
          if (entry.isIntersecting && idx === -1) {
            active.push(entry.target);
            if (!looping) { looping = true; requestAnimationFrame(ptick); }
          } else if (!entry.isIntersecting && idx !== -1) {
            active.splice(idx, 1);
          }
        });
      }, { threshold: 0 });
      pEls.forEach(function (el) { pio.observe(el); });
    }
  }

  /* ---- 10) count: gorunume girince 0'dan data-target'a say ---- */
  var cEls = document.querySelectorAll('.ag-fx-count[data-target]');
  if (cEls.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        if (REDUCED) { el.textContent = target; return; }
        var start = null;
        var dur = 900;
        function tick(now) {
          if (start === null) start = now;
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(tick);
          else el.textContent = target;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: .4 });
    cEls.forEach(function (el) { cio.observe(el); });
  }
})();